module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACLSURBVEhL3ZVBCoBADAP3d4r/f4H6j7U9FCykZNfgQQcCpWlybfsdm+k09Yfy7GoqOUwoOKPdVBJHFaovFzBfLmC+XMB8uYD5cgHz4cF9V80B2iVYqJoDtEuwUDUHaJdgoWoO0C7BDlRfLmC+XMB8uYD5cgHz3/8H/o38AAVH5NnFRInAKLP3n6G1Cxn6sY6x4prLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-wardrobe/dark/24.png
// module id = 2540
// module chunks = 2